import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { WINDOW } from '@services';
import { cleanPhone } from '@shared';

@Component({
  selector: 'app-personal-manager-stub',
  templateUrl: './personal-manager-stub.component.html',
  styleUrls: ['./personal-manager-stub.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalManagerStubComponent {}
